/**
 * @author Martin Leonov <martin.leonov@ki-wi.cz>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

import isNil from 'lodash/isNil';

class UnixTimestamp {
  /**
   * Vytvoří instanci.
   * @returns {UnixTimestamp} Nová instance.
   */
  constructor() {
    this.offsetTime = 0;
  }

  /**
   * Vypočte offset času na základě informací z heartbeat.
   * @param {HeartbeatFetched} heartbeatFetched
   * @returns {void}
   */
  setOffsetFromHeartbeatInfo(heartbeatFetched) {
    const { fetchEndTimeMillis, heartbeatInfo } = heartbeatFetched;
    if (isNil(heartbeatInfo.currentTimeMillis)) {
      return;
    }

    this.offsetTime = heartbeatInfo.currentTimeMillis - fetchEndTimeMillis;
  }

  /**
   * Zjistí offset oproti referenčnímu času.
   * @returns {number} Offset oproti referenčnímu času.
   */
  offset() {
    return this.offsetTime;
  }

  /**
   * Získá aktuální čas v ms od Unix epochy.
   * @returns {number} Unix time v ms od epochy.
   */
  now() {
    return Date.now();
  }
}

export default UnixTimestamp;
